<template>
  <div>
    <div :class="classes">
      <InsightPageset :code="pageset" />
    </div>
    <slot name="pageend">
      <div>
        <!-- used by vue2-telport -->
        <span id="page-end" />
        <span name="report-end" />
      </div>
    </slot>
  </div>
</template>

<script>
export default {
  name: "Applications",
  data() {
    return {
      pageset: window.PAGESET,
      classes: window.INSIGHT_NO_CONTAINER ? 'container-fluid': 'container-fluid container--openapp'
    };
  },
};
</script>
